// @flow strict
import React from 'react';
import { Link } from 'gatsby';

import styles from './Menu.module.scss';

type Props = {
  menu: {
    label: string,
    path: string
  }[]
};

const Menu = ({ menu, path }: Props) => {

  //  if is a post subdir set post menu to active
  //const checkActive = (label) => (label == "Posts" && path && (path.includes('/posts/') || path.includes('page')) ? styles['menu__list-item-link--active'] : styles['menu__list-item-link'])


  const checkActive = (label) => (
    (label == "Posts" && path && (path.includes('/posts/') || path.includes('page/')))
    ||
    (label == "Categories" && path && (path.includes('/category/')))
    ||
    (label == "Tags" && path && (path.includes('/tag/')))
  ) ?
    styles['menu__list-item-link--active']
    :
    styles['menu__list-item-link']
    ;


  return (
    < nav className={styles['menu']} >
      <ul className={styles['menu__list']}>
        {menu.map((item) => (
          < li className={styles['menu__list-item']} key={item.path} >
            <Link
              to={item.path}
              className={checkActive(item.label)}
              activeClassName={styles['menu__list-item-link--active']}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav >
  )
};

export default Menu;
